"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarkMetalBaseMaterial = exports.MetalBaseMaterial = exports.SelectedBaseMaterial = exports.BaseMaterial = void 0;
const BaseMaterial_3d_1 = __importDefault(require("./BaseMaterial.3d"));
exports.BaseMaterial = BaseMaterial_3d_1.default;
const MetalBaseMaterial_3d_1 = __importDefault(require("./MetalBaseMaterial.3d"));
exports.MetalBaseMaterial = MetalBaseMaterial_3d_1.default;
const ColoredMetalBaseMaterial_3d_1 = __importDefault(require("./ColoredMetalBaseMaterial.3d"));
exports.DarkMetalBaseMaterial = ColoredMetalBaseMaterial_3d_1.default;
const SelectedBaseMaterial_3d_1 = __importDefault(require("./SelectedBaseMaterial.3d"));
exports.SelectedBaseMaterial = SelectedBaseMaterial_3d_1.default;
